import $axios from '@/axios-instance.js'

export const projectService = {
  // getByProjectId,
  getByOwnerId,
  getByReviwerId,
  getListData,
  // getProjectsList,
  getById,
  getByProjectCode,
  create,
  getAllTags,
  addTagsToProject,
  update,
  getAll,
  delete: _delete
}

let cancellationSource

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/projects/get-all`).then(response => {
    return response.data
  })
}

function getByOwnerId (id) {
  return $axios.get(`${process.env.ROOT_API}/users/${id}/projectowner`).then(response => {
    return response.data
  })
}

function getByReviwerId (id) {
  return $axios.get(`${process.env.ROOT_API}/users/${id}/projectreviewer`).then(response => {
    return response.data
  })
}

// Old one
// function getListData (filter, page) {
//   return $axios.get(`${process.env.ROOT_API}/projects`, {
//     params: Object.assign({ currentPage: page }, filter),
//     cancelToken: cancellationSource.token
//   }).then(response => {
//     return response.data
//   })
// }

function getListData (filter, page) {
  let fixedFilter = Object.assign({ currentPage: page, type: 'Projects' }, filter)
  let tagIds = (fixedFilter.tags && fixedFilter.tags) ? fixedFilter.tags.map(x => x.value) : null
  fixedFilter.tagIds = tagIds

  if (cancellationSource) {
    cancellationSource.cancel('cancel previous request')
  }

  const CancelToken = $axios.CancelToken
  cancellationSource = CancelToken.source()

  return $axios.post(`${process.env.ROOT_API}/projects/list`, Object.assign({ currentPage: page }, fixedFilter), { cancelToken: cancellationSource.token }
  ).then(response => {
    return response.data
  })
}

function getByProjectCode (projectCode) {
  return $axios.get(`${process.env.ROOT_API}/projects/code/${projectCode}`).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/projects/${id}`).then(response => {
    return response.data
  })
}

function create (project) {
  return $axios.post(`${process.env.ROOT_API}/projects`, project).then(response => {
    return response.data
  })
}

function getAllTags () {
  return $axios.get(`${process.env.ROOT_API}/tags/get-all`).then(response => {
    return response.data
  })
}

function addTagsToProject (projectId, tags) {
  return $axios.post(`${process.env.ROOT_API}/tags/${projectId}`, tags).then(response => {
    return response.data
  })
}

function update (project) {
  return $axios.put(`${process.env.ROOT_API}/projects/${project.projectId}`, project).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/projects/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/project.service.js